var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.356 13.144a12.634 12.634 0 0 1-2.638-3.809.749.749 0 0 1 .166-.827l.819-.818c.671-.67.671-1.62.085-2.206L8.614 4.31a2 2 0 0 0-2.828 0l-.652.652c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.45 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.65a2 2 0 0 0 0-2.829l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.66 12.66 0 0 1-3.809-2.64v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPhone;